import { configureStore } from '@reduxjs/toolkit'

import createRootReducer from '@redux/rootReducer'
import lastModifiedMiddleware from '@redux/middleware/lastModified'

const store = configureStore({
  reducer: createRootReducer(),
  middleware: getDefaultMiddleware => getDefaultMiddleware({ immutableCheck: false }).concat(lastModifiedMiddleware),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
